import { http } from "./config";

let authData = {};

if (localStorage.getItem("vibbra-user") != null) {
  authData = JSON.parse(localStorage.getItem("vibbra-user"));
  http.defaults.headers.common["access-token"] = authData.access_token;
  http.defaults.headers.common.client = authData.client_code;
  http.defaults.headers.common.expiry = authData.expiry;
  http.defaults.headers.common["token-type"] = "Bearer";
  http.defaults.headers.common.uid = authData.uid;
}

export default {
  fetch_csat_vibbra: user =>
    http.get(`/rating/csat-vibbra?user_type=${user.type}&user_id=${user.id}`),
  fetch_nps_vibbra: user =>
    http.get(`/rating/nps_vibbra?user_type=${user.type}&user_id=${user.id}`, {
      timeout: 99999
    }),
  fetch_csat_vibbrante_close_sprint: (user, contract_id) =>
    http.get(
      `rating/csat-vibbrante-close-sprint?event=close_sprint&user_type=${
        user.type
      }&user_id=${user.id}&contract_id=${contract_id}&only_trigger=true`
    ),
  fetch_csat_client_close_sprint: () => http.get("rating/csat-client-project?force=true"),
  submit_rating: payload => http.post("rating", payload),
  createRating: payload => http.post("rating/new", payload)
};



// WEBPACK FOOTER //
// ./src/api/rating.js